import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { environmentAtom } from '@root/shared'
import { apiRequest } from '@root/shared/api'
import { tradeApiClientAtom } from '@root/shared/api/trade-api-client-atom'

import { Profile } from '../model'

import type { DelugeId } from '@root/entities/user-short'

export const fetchUserProfileRequestAction = action(
  async (
    ctx,
    { network, delugeId }: { network: Network.Network; delugeId?: DelugeId },
  ) => {
    const {
      assets: { avatarsHost, tokenLogosHost },
    } = ctx.get(environmentAtom)

    const { tradeApiClient } = ctx.get(tradeApiClientAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userProfileList, [
        {
          network: Network.toDto(network),
          delugeId,
        },
      ]),
    )

    return pipe(
      result,
      Result.map((it) => Profile.fromDto(it, avatarsHost, tokenLogosHost)),
    )
  },
  'fetchUserProfileRequestAction',
)
